import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import type { UnitEditability } from 'v5/core/form-schema/formSchema.types';

type ReadOnlyReason = Extract<UnitEditability, { type: 'read-only' }>['reason'];

/** Why a unit (or, for `no-capability`, the whole resource) can't be edited. */
export function useReadOnlyReasonLabel(): (
  reason: ReadOnlyReason,
  subject: 'field' | 'resource'
) => string {
  const { t } = useTranslation('patterns', {
    keyPrefix: 'SchemaForm.readOnlyReason'
  });
  return useCallback(
    (reason, subject) => {
      switch (reason) {
        case 'no-capability':
          return subject === 'field'
            ? t('noCapability')
            : t('noCapabilityResource');
        case 'other-workspace':
          return t('otherWorkspace');
        case 'archived-workspace':
          return t('archivedWorkspace');
        case 'display-only':
          return t('displayOnly');
        case 'locked-by-type':
          return t('lockedByType');
      }
    },
    [t]
  );
}
